import { render, staticRenderFns } from "./renameDialog.vue?vue&type=template&id=7c0959b7"
import script from "./renameDialog.vue?vue&type=script&lang=js"
export * from "./renameDialog.vue?vue&type=script&lang=js"
import style0 from "./renameDialog.vue?vue&type=style&index=0&id=7c0959b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports